// The order address only comes back as one formatted string, and the backend writes
// it differently from the address book: the house number can carry the descriptive
// one ("949/67" vs "67") and the city can be the district instead ("Brno" vs
// "Veveří"). So the match is on tokens — street name, house number, postal code —
// and never on the whole string.
// US street words come back spelled out or abbreviated ("North Meridian Avenue" vs
// "N Meridian Ave"), so both sides are folded to the short form
const SHORT = {
  north: 'n',
  south: 's',
  east: 'e',
  west: 'w',
  avenue: 'ave',
  street: 'st',
  road: 'rd',
  boulevard: 'blvd',
  drive: 'dr',
  lane: 'ln',
  court: 'ct',
  place: 'pl',
  highway: 'hwy',
  parkway: 'pkwy',
};

const tokenize = (value) => {
  const lower = (value || '').toString().toLowerCase().replace(/ß/g, 'ss');
  return {
    // diacritics drop out on both sides, so they stay comparable
    letters: lower
      .split(/[^a-z]+/)
      // German streets carry the suffix in the word: "-str." as "-strasse"
      .map((word) => SHORT[word] || word.replace(/strasse$/, 'str'))
      .join(''),
    numbers: lower.match(/\d+/g) || [],
    digits: lower.replace(/\D/g, ''),
  };
};

// a saved address is the one the order ships to when the street name and postal
// code are both in the formatted string, and they share a house number
export function isCurrentAddress(addr, formatted) {
  if (!addr || !formatted) {
    return false;
  }
  const target = tokenize(formatted);
  const street = tokenize(addr.addressLine1);
  const zip = tokenize(addr.postalCode);

  // a postal code without digits (test data, free-text entries) is compared on letters
  const zipKey = zip.digits ? 'digits' : 'letters';

  if (!street.letters || !zip[zipKey]) {
    return false;
  }
  if (!target.letters.includes(street.letters)) {
    return false;
  }
  if (!target[zipKey].includes(zip[zipKey])) {
    return false;
  }
  // ponytail: any shared house number is enough, so both "949/67" and "67" match;
  // two entries on the same street could tie, and the first one wins
  return (
    street.numbers.length === 0 ||
    street.numbers.some((n) => target.numbers.includes(n))
  );
}
